module.exports = __webpack_public_path__ + "img/toExamined-end.533f1cf8.png";